/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef } from "react";
import { getHubbelPageData, openImageViewModal } from "../../helpers";
import { Link, useParams } from "react-router-dom";
import "./Web1920101.css";
import background_1 from "../../static/n-images/The Antennae Galaxies.jpg";
import background_2 from "../../static/n-images/The Mice.jpg";
import background_3 from "../../static/n-images/arp282.jpeg";
import background_4 from "../../static/n-images/arp91.jpg";
import background_5 from "../../static/n-images/arpcropped.jpg";
import nasalogo from "../../static/img/NASA_Insignia.png";
import background_6 from "../../static/n-images/273.jpg";
import background_7 from "../../static/n-images/ante.jpg";

function Web1920101(props) {
  let { reload } = useParams();
  const {
    group583,
    group42,
    group287,
    group45,
    learnMore,
    rocket,
    flyToIt,
    wingright,
    leftwing,
    flyBackToSolarSystem,
    travelAgainInGalaxies,
    click_me,
  } = props;

  /* panel-js-start */
  const slideToggleButton = useRef();
  const slideToggleBox = useRef();

  useEffect(() => {
    if (slideToggleBox && slideToggleBox.current) {
      const stButton = slideToggleButton.current;
      stButton.addEventListener("click", function () {
        slideToggleBox.current.classList.toggle("panel-active");
        slideToggleButton.current.classList.toggle("panel-btn-active");
      });
    }
  }, [slideToggleBox]);
  /* panel-js-start */

  let onPageData = [
    {
      randomPageTitle: "The Antennae Galaxies",
      randomPageDescription:
        "These two spiral galaxies started to interact a few hundred million years ago, making the Antennae galaxies, as they are called, one of the nearest and youngest examples of a pair of colliding galaxies. Nearly half of the faint objects in the Antennae image are young clusters of tens of thousands of stars. The orange blobs to the left and right are the two cores of the original galaxies and consist mainly of old stars criss-crossed by filaments of dust. ",
      learnMoreLink: (
        <React.Fragment>
          <div className="view_img-rem">
            <a target="_blank" rel="noreferrer" href="https://science.nasa.gov/missions/hubble/super-star-clusters-in-the-antennae-galaxies/">Learn More</a>
            <span>|</span>
            <h3 onClick={(e) => openImageViewModal(background_7, e)}>
              <u>View Full Image</u>
            </h3>
          </div>
        </React.Fragment>
      ),
      background: background_1,
      cssClass: "",
    },

    {
      randomPageTitle: "The Mice",
      randomPageDescription:
        'These colliding galaxies, which will one day merge, are nicknamed "The Mice" because of the long tails of stars and gas pulled from each galaxy by their gravitational interaction. The formation of hot blue stars was triggered by the tidal forces of their gravitational interaction and streams of material flow between the two galaxies. Material in the tails will either fall back into the merged galaxies or orbit in the halo of the newly formed elliptical galaxy.',
      learnMoreLink: (
        <React.Fragment>
          <div className="view_img-rem">
            <a target="_blank" rel="noreferrer" href="https://science.nasa.gov/missions/hubble/hubbles-new-camera-delivers-breathtaking-views-of-the-universe/">Learn More</a>
            <span>|</span>
            <h3 onClick={(e) => openImageViewModal(background_2, e)}>
              <u>View Full Image</u>
            </h3>
          </div>
        </React.Fragment>
      ),
      background: background_2,
      cssClass: "",
    },
    {
      randomPageTitle: "Arp 282",
      randomPageDescription:
        "Arp 282 is an interacting galaxy pair composed of galaxy NGC 169 (bottom) and the galaxy IC 1559 (top). An important aspect of how galaxies evolve is the way they interact with one another. Galaxies can merge, collide, or brush past one another – each interaction significantly affecting their shapes and structures. As common as such interactions may be, it is rare to view two galaxies interacting in such a visibly dynamic way.",
      learnMoreLink: (
        <React.Fragment>
          <div className="view_img-rem">
            <a target="_blank" rel="noreferrer" href="https://science.nasa.gov/missions/hubble/hubble-views-a-cosmic-interaction/">Learn More</a>
            <span>|</span>
            <h3 onClick={(e) => openImageViewModal(background_3, e)}>
              <u>View Full Image</u>
            </h3>
          </div>
        </React.Fragment>
      ),
      background: background_3,
      cssClass: "",
    },
    {
      randomPageTitle: "Arp 91",
      randomPageDescription:
        "Galaxy pair Arp 91 provides a vivid example of galactic interaction. The lower galaxy, NGC 5953, is clearly tugging at its partner NGC 5954, which looks like it is extending one spiral arm downward. The immense gravitational attraction of the two galaxies is causing them to interact. Most astronomers think that collisions between spiral galaxies lead to the formation of another type of galaxy, known as elliptical galaxies.",
      learnMoreLink: (
        <React.Fragment>
          <div className="view_img-rem">
            <a target="_blank" rel="noreferrer" href="https://science.nasa.gov/missions/hubble/hubble-detects-a-dangerous-dance/">Learn More</a>
            <span>|</span>
            <h3 onClick={(e) => openImageViewModal(background_4, e)}>
              <u>View Full Image</u>
            </h3>
          </div>
        </React.Fragment>
      ),
      background: background_4,

      cssClass: "",
    },
    {
      randomPageTitle: "Arp 273",
      randomPageDescription:
        "The disk of the larger of two interacting galaxies is distorted into a rose-like shape by the gravitational pull of the companion galaxy below it. A swath of blue jewels across the top is the combined light from clusters of intensely bright and hot young blue stars. The smaller, nearly edge-on companion shows signs of intense star formation at its nucleus, perhaps triggered by the encounter with the companion galaxy.",
      learnMoreLink: (
        <React.Fragment>
          <div className="view_img-rem">
            <a target="_blank" rel="noreferrer" href="https://science.nasa.gov/missions/hubble/nasas-hubble-celebrates-21st-anniversary-with-rose-of-galaxies/">Learn More</a>
            <span>|</span>
            <h3 onClick={(e) => openImageViewModal(background_6, e)}>
              <u>View Full Image</u>
            </h3>
          </div>
        </React.Fragment>
      ),
      background: background_5,
      cssClass: "zoom-img",
    },
  ];

  let randomObject = getHubbelPageData(onPageData, reload);

  return (
    <div className="container-center-horizontal">
      {/* panel-div-start */}
      <div className="panel">
        <button className="panel-toggle-button" ref={slideToggleButton}>
          <p className="open-panel">
            <img className="arrow" src={click_me} /> OPEN CONTROL PANEL
          </p>
          <p className="close-panel">
            <img className="arrow" src={click_me} /> CLOSE CONTROL PANEL
          </p>
        </button>
        <div className="panel-box panel-active" ref={slideToggleBox}>
          <div className="contentbox">
            <div className="left">
              <img src={leftwing} className="wing_left" />
              <div className="the-antennae-galaxies lato-bold-white-30px">
                {randomObject.randomPageTitle}
              </div>

              {randomObject.learnMoreLink}

              <div className="the-antennae-galaxie lato-medium-white-26px">
                {randomObject.randomPageDescription}
              </div>
            </div>

            <div className="right">
              <img src={wingright} className="wing_right" />

              {randomObject.randomPageTitle === "Arp 273" && (
                <>
                  <Link to="/web-1920-187">
                    <div className="innerbtn-btn fly">
                      <div className="web192010-btn-img">
                        <div
                          className="web192010-bg-img"
                          style={{ backgroundImage: `url(${rocket})` }}
                        ></div>
                      </div>
                      {flyToIt}
                    </div>
                  </Link>
                </>
              )}

              <Link to="/i-want-to-see-a-different-galaxy">
                <div className="innerbtn-btn1">
                  <div className="web192010-btn-img">
                    <div
                      className="web192010-bg-img"
                      style={{ backgroundImage: `url(${group45})` }}
                    ></div>
                  </div>
                  {travelAgainInGalaxies}
                </div>
              </Link>

              <Link to="/investigate-our-solar-system">
                <div className="innerbtn-btn1">
                  <div className="web192010-btn-img">
                    <div
                      className="web192010-bg-img"
                      style={{ backgroundImage: `url(${group42})` }}
                    ></div>
                  </div>
                  {flyBackToSolarSystem}
                </div>
              </Link>

              <Link to="/explore-our-milky-way">
                <div className="innerbtn-btn1">
                  <div className="web192010-btn-img">
                    <div
                      className="web192010-bg-img"
                      style={{ backgroundImage: `url(${group287})` }}
                    ></div>
                  </div>
                  {learnMore}
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* panel-div-end */}
      <div className="web-1920-101 screen">
        <div className="overlap-group7-4 overlap-group">
          <img
            className={`x47508827662_0fb5ab33c6_4k`}
            src={randomObject.background}
          />

          <div className="rectangle-2-19 border-1px-dove-gray"></div>

          <Link to="/web-1920-10">
            <div
              className="group-583-12"
              style={{ backgroundImage: `url(${group583})` }}
            ></div>
          </Link>
        </div>
      </div>
      <Link to="/web-1920-10">
        <div
          className="group-583_13 home-btn-pos"
          style={{ backgroundImage: `url(${group583})` }}
        ></div>
      </Link>

      {/* ham-menu-start */}

      <div className="container">
        <input type="checkbox" name="" id="" className="check" />
        <ul className="menu-items">
          <Link to="/i-want-to-see-a-different-galaxy">
            <div className="innerbtn-btn1">{travelAgainInGalaxies}</div>
          </Link>

          <Link to="/investigate-our-solar-system">
            <div className="innerbtn-btn1">{flyBackToSolarSystem}</div>
          </Link>

          <Link to="/explore-our-milky-way">
            <div className="innerbtn-btn1">{learnMore}</div>
          </Link>
        </ul>
        <div className="ham-menu">
          <span className="line line1"></span>
          <span className="line line2"></span>
          <span className="line line3"></span>
        </div>
      </div>

      {/* ham-menu-end */}
      <a href="https://www.nasa.gov/" className="nasalogo" target="_blank"  rel="noreferrer"><img alt="img" src={nasalogo} /> </a>

      <div className="hds-footer-socials margin-bottom-2">
        <h3 className="heading-16 color-carbon-40 margin-bottom-2">Visit Us <br></br><a className="text-dark" href="https://science.nasa.gov/mission/hubble" target="_blank" rel="noreferrer">nasa.gov/hubble</a></h3>

        <h4><span>@NASA</span>Hubble</h4>
        <ul className="social-icons margin-bottom-3">
          <li>
            <a href="https://www.facebook.com/NASAHubble" title="Hubble on Facebook" target="_blank" rel="noreferrer"><svg alt="Facebook" width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="https://www.w3.org/2000/svg"><path d="M8.55557 4.25966H6.95557C6.31794 4.25966 6.1852 4.52158 6.1852 5.18173V6.63003H8.55557L8.30787 9.0004H6.1852V17.2967H2.62965V9.0004H0.259277V6.63003H2.62965V3.89462C2.62965 1.79803 3.73306 0.704102 6.21957 0.704102H8.55557V4.25966Z" fill="#F7F5F4"></path></svg></a>
          </li>
          <li>
            <a href="https://www.instagram.com/NASAHubble/" title="Hubble on Instagram" target="_blank" rel="noreferrer"><svg alt="Instagram" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="https://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M4.74015 9.0004C4.74015 11.3542 6.64829 13.2611 9.00089 13.2611C11.3535 13.2611 13.2616 11.353 13.2616 9.0004C13.2616 6.6478 11.3535 4.74084 9.00089 4.74084C6.64829 4.74084 4.74015 6.6478 4.74015 9.0004ZM11.7625 9.00037C11.7625 10.5281 10.524 11.7654 8.9975 11.7654C7.47098 11.7654 6.23247 10.5281 6.23247 9.00037C6.23247 7.47267 7.47098 6.23533 8.9975 6.23533C10.524 6.23533 11.7625 7.47267 11.7625 9.00037Z" fill="#F7F5F4"></path><path d="M12.4344 4.57255C12.4344 5.12247 12.88 5.5681 13.4299 5.5681C13.9798 5.5681 14.4255 5.12129 14.4255 4.57255C14.4255 4.02262 13.9798 3.57699 13.4299 3.57699C12.88 3.57699 12.4344 4.02262 12.4344 4.57255Z" fill="#F7F5F4"></path><path fillRule="evenodd" clipRule="evenodd" d="M12.4225 17.2469C15.4317 17.1083 17.1111 15.4371 17.2474 12.4208C17.2877 11.5367 17.2972 11.2534 17.2972 9.0004C17.2972 6.74736 17.2877 6.46529 17.2474 5.57995C17.1123 2.57077 15.4388 0.893731 12.4225 0.755065C11.5372 0.713583 11.2539 0.704102 9.00089 0.704102C6.74785 0.704102 6.46578 0.713583 5.58044 0.755065C2.56652 0.892546 0.893034 2.56484 0.754367 5.57995C0.714071 6.46529 0.70459 6.74736 0.70459 9.0004C0.70459 11.2534 0.714071 11.5367 0.754367 12.4208C0.893034 15.4348 2.56533 17.1083 5.58044 17.2469C6.46578 17.2872 6.74785 17.2967 9.00089 17.2967C11.2539 17.2967 11.5372 17.2872 12.4225 17.2469ZM9.00089 2.19981C11.216 2.19981 11.4791 2.20692 12.3538 2.24721C14.6021 2.35032 15.651 3.41699 15.7553 5.64869C15.7944 6.52336 15.8027 6.78529 15.8027 9.0004C15.8027 11.2155 15.7944 11.4786 15.7553 12.3533C15.651 14.5838 14.6044 15.6528 12.3538 15.7548C11.4791 15.7951 11.2172 15.8034 9.00089 15.8034C6.78577 15.8034 6.52266 15.7939 5.64918 15.7548C3.39378 15.6517 2.35081 14.5803 2.2477 12.3533C2.20859 11.4774 2.19911 11.2155 2.19911 9.0004C2.19911 6.78529 2.20859 6.52336 2.2477 5.64869C2.35081 3.41581 3.39852 2.35032 5.64918 2.24721C6.52385 2.2081 6.78577 2.19981 9.00089 2.19981Z" fill="#F7F5F4"></path></svg></a>
          </li>
          <li>
            <a href="https://twitter.com/nasahubble" title="Hubble on X" target="_blank" rel="noreferrer"><svg alt="X" width="1200" height="1227" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"></path></svg></a>
          </li>
            <li>
            <a href="https://www.flickr.com/photos/nasahubble/" title="Hubble on Flickr" target="_blank" rel="noreferrer">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Hubble on Flickr</title><path d="M11 12C11 14.7615 8.76146 17 5.99998 17 3.23849 17 1 14.7615 1 12 1 9.23899 3.23849 7 5.99998 7 8.76146 7 11 9.23899 11 12ZM23 12C23 14.7615 20.7615 17 18 17 15.2385 17 13 14.7615 13 12 13 9.23899 15.2385 7 18 7 20.7615 7 23 9.23899 23 12Z"></path></svg>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Web1920101;